import { render } from "./SettingsButtonAvatarFileUpload.vue?vue&type=template&id=e5d9bd24"
import script from "./SettingsButtonAvatarFileUpload.vue?vue&type=script&lang=js"
export * from "./SettingsButtonAvatarFileUpload.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__